export default __webpack_public_path__ + "static/media/AK.104f4796.png";